module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/72637af5b52fbfac1fb39b05e648100f.png";